module.exports = __webpack_public_path__ + "static/pinterest-25b2e961c471b918523aeead8a15527e.png";